import posthog, { isAnalyticsEnabled } from "./posthog";

type Props = Record<string, unknown>;

function toError(err: unknown): Error {
  if (err instanceof Error) return err;
  if (typeof err === "string") return new Error(err);
  try {
    return new Error(JSON.stringify(err));
  } catch {
    return new Error(String(err));
  }
}

export const logger = {
  debug(...args: unknown[]) {
    if (import.meta.env.DEV) console.debug(...args);
  },
  info(message: string, props?: Props) {
    console.info(message, props ?? "");
    if (isAnalyticsEnabled()) posthog.capture(message, props);
  },
  warn(message: string, props?: Props) {
    console.warn(message, props ?? "");
    if (isAnalyticsEnabled()) posthog.capture(`warn:${message}`, props);
  },
  error(tag: string, err: unknown, props?: Props) {
    const error = toError(err);
    console.error(tag, error, props ?? "");
    if (isAnalyticsEnabled()) {
      posthog.captureException(error, { tag, ...(props ?? {}) });
    }
  },
  event(name: string, props?: Props) {
    if (isAnalyticsEnabled()) posthog.capture(name, props);
  },
};

export default logger;
